module.exports = __webpack_public_path__ + "static/media/facebook_drivelah_2.ac093670.jpg";